import React, {useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import '../styles/calculatorForm.scss';
import { FormControl, Button, Form } from 'react-bootstrap';
import { LabelTooltip } from '../components/label-tooltip';


export default function CalculatorForm({calculate}) {

    const [calculationForm, setCalculationForm] = useState({
        bloodType: 1,
        age: 55,
        oxygenRequirement: 0,
        heartDisease: 0,
        diabetes: 0,
        pulmonary: 0
    });
    
    const handleChange = event => {
        let fieldName = event.target.name;
        let fleldVal = event.target.value;
        setCalculationForm({ ...calculationForm, [fieldName]: fleldVal } )
    };
   

    return <div className="calculator-form">
            <h3 className="t-heading2 t-sans mb-4">Answer the questions below to determine if treatment with Convalescent Plasma is right for your patient</h3>
            <Form.Group className="mb-4" controlId="formGroupEmail">
                <Form.Label className="calculator-label">
                    <span>1. Oxygen requirements</span>
                    <LabelTooltip
                        tooltipId="1_oxygen_requirements"
                    />
                </Form.Label>
                <Form.Select value={calculationForm.oxygenRequirement} onChange={handleChange} name="oxygenRequirement" placeholder="Please select one">
                    <option value="0">No oxygen supplementation is required</option>
                    <option value="1">Oxygen by mask or nasal prongs is required</option>
                    <option value="2">Oxygen by non-invasive ventilation or high flow is required</option>
                </Form.Select>
            </Form.Group>
            <Form.Group className="mb-4" controlId="formGroupEmail">
                <Form.Label className="calculator-label">
                    <span>2. Age in years</span>
                    <LabelTooltip
                        tooltipId="2_age_in_years"
                    />
                </Form.Label>
                <FormControl
                    placeholder="Age"
                    aria-label="Age"
                    name="age"
                    value={calculationForm.age}
                    onChange={handleChange}

                    aria-describedby="basic-addon1"
                />
            </Form.Group>
            <Form.Group className="mb-4" controlId="formGroupEmail">
                <Form.Label className="calculator-label">
                    <span>3. History of heart disease</span>
                    <LabelTooltip
                        tooltipId="3_history_of_heart_disease"
                    />
                </Form.Label>
                <div className="calculator-check-group">
                    <Form.Check
                        className="calculator-check-unit"
                        inline
                        label="Yes"
                        onChange={handleChange}
                        value={'1'}
                        defaultChecked={(calculationForm.heartDisease || calculationForm.heartDisease === '1') ? true : false}
                        name="heartDisease"
                        type={'radio'}
                        id={`inline-radio-1`}
                    />
                    <Form.Check
                        className="calculator-check-unit"
                        inline
                        label="No"
                        defaultChecked={(!calculationForm.heartDisease || calculationForm.heartDisease === '0') ? true : false}
                        onChange={handleChange}
                        value={'0'}
                        name="heartDisease"
                        type={'radio'}
                        id={`inline-radio-2`}
                    />
                </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="formGroupEmail">
                <Form.Label className="calculator-label">
                    <span>4. History of diabetes</span>
                    <LabelTooltip
                        tooltipId="4_history_of_diabetes"
                    />
                </Form.Label>
                <div className="calculator-check-group">
                    <Form.Check
                        className="calculator-check-unit"
                        inline
                        label="Yes"
                        defaultChecked={(calculationForm.diabetes || calculationForm.diabetes === '1') ? true : false}
                        onChange={handleChange}
                        value={1}
                        name="diabetes"
                        type={'radio'}
                        id={`inline-radio-3`}
                    />
                    <Form.Check
                        className="calculator-check-unit"
                        inline
                        label="No"
                        defaultChecked={(!calculationForm.diabetes || calculationForm.diabetes === '0') ? true : false}
                        onChange={handleChange}
                        value={0}
                        name="diabetes"
                        type={'radio'}
                        id={`inline-radio-4`}
                    />
                </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="formGroupEmail">
                <Form.Label className="calculator-label">
                    <span>5. History of pulmonary disease</span>
                    <LabelTooltip
                        tooltipId="5_history_of_pulmonary_disease"
                    />
                </Form.Label>
                <div className="calculator-check-group">
                    <Form.Check
                        className="calculator-check-unit"
                        inline
                        label="Yes"
                        name="pulmonary"
                        defaultChecked={(calculationForm.pulmonary || calculationForm.pulmonary === '1') ? true : false}
                        onChange={handleChange}
                        value={1}
                        type={'radio'}
                        id={`inline-radio-5`}
                    />
                    <Form.Check
                        className="calculator-check-unit"
                        inline
                        label="No"
                        defaultChecked={(!calculationForm.pulmonary || calculationForm.pulmonary==='0') ? true : false}
                        onChange={handleChange}
                        value={0}
                        name="pulmonary"
                        type={'radio'}
                        id={`inline-radio-6`}
                    />
                </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="formGroupEmail">
                <Form.Label className="calculator-label">
                    <span>6. Blood type (skip if not available)</span>
                    <LabelTooltip
                        tooltipId="6_blood_type"
                    />
                </Form.Label>
                <Form.Select onChange={handleChange}
                    name="bloodType"
                    value={calculationForm.bloodType}>
                    <option value="0">Not sure</option>
                    <option value="1">O</option>
                    <option value="2">A</option>
                    <option value="3">B</option>
                    <option value="4">AB</option>

                </Form.Select>
            </Form.Group>
            <Button variant="btn primary" onClick={() => {calculate(calculationForm);}}>Run Calculator</Button>
            <h3 className="t-heading2 mt-4 mb-3 calculator-how">How is CCP TBI Calculated?</h3>
            <p className="t-body1">The first 5 questions above are necessary to compute the TBI. Blood type is an optional field, but the predicted benefit from treatment with CCP will be more precise when blood type is available.</p>
      
        </div>


}